<template>
    <BaseForm>
        <template #fields>
            <MultiLinkGroup>
                <MultiLink
                    :label="$t('other-links-internal')"
                    :links="values.otherLinksInternal"
                    :error-messages="errors.otherLinksInternal"
                    @input="setFieldValue('otherLinksInternal', $event)"
                    @delete="setFieldValue('otherLinksInternal', $event)"
                />
                <MultiLink
                    :label="$t('other-links-external')"
                    :links="values.otherLinksExternal"
                    :error-messages="errors.otherLinksExternal"
                    @input="setFieldValue('otherLinksExternal', $event)"
                    @delete="setFieldValue('otherLinksExternal', $event)"
                />
            </MultiLinkGroup>
        </template>
    </BaseForm>
</template>
<script setup lang="ts">
import BaseForm from '@/components/Form/BaseForm.vue';
import { useMultiLink } from '@/components/MultiLink/composables/useMultiLink';
import MultiLink from '@/components/MultiLink/MultiLink.vue';
import MultiLinkGroup from '@/components/MultiLink/MultiLinkGroup.vue';
import { useEventInjection } from '@/event/composables/useEventInjection';
import { useForm } from '@/forms/composables/useForm';
import { computed } from 'vue';
import { EventOtherLinksSchema } from '../schemas';

const { event, createEventMultiLink } = useEventInjection();
const { getFormFieldLinks, saveMultiLinkFields } = useMultiLink(createEventMultiLink);

const otherLinksInternalId = computed(() => event.value?.otherLinksInternal?.id);
const otherLinksExternalId = computed(() => event.value?.otherLinksExternal?.id);

const otherLinksInternalLinks = computed(() => event.value?.otherLinksInternal?.links.nodes ?? []);
const otherLinksExternalLinks = computed(() => event.value?.otherLinksExternal?.links.nodes ?? []);

const { errors, values, setFieldValue, validate, onDiscard, resetForm } = useForm(
    EventOtherLinksSchema,
    computed(() => ({
        otherLinksInternal: getFormFieldLinks(otherLinksInternalLinks),
        otherLinksExternal: getFormFieldLinks(otherLinksExternalLinks),
    })),
);

async function save() {
    const valid = await validate();
    if (valid) {
        await saveMultiLinkFields([
            { id: otherLinksInternalId.value, fieldName: 'otherLinksInternal', links: values.value.otherLinksInternal },
            { id: otherLinksExternalId.value, fieldName: 'otherLinksExternal', links: values.value.otherLinksExternal },
        ]);
    }
}

defineExpose({ save, onDiscard, resetForm });
</script>
